import { client as request } from "./request";
import Icon from "@/models/icon";

/**
 * アイコンの候補を取得する
 */
export async function getIcons() {
  const res = await request.get("get_icons.php");
  return res.icons as Icon[];
}

/**
 * アイコンを設定する
 */
export async function saveIcon(id: number) {
  const d = new FormData();
  d.append("iconId", String(id));
  await request.post("save_icon.php", d);
}
